// Allows child routes (e.g. the dashboard builder) to programmatically collapse the sidebar.
import { createContext, useContext } from "react";

interface SidebarContextValue {
  collapseSidebar: () => void;
}

export const SidebarContext = createContext<SidebarContextValue>({
  collapseSidebar: () => {},
});

export function useSidebarContext() {
  return useContext(SidebarContext);
}
